import { res } from './res';

export const labelsES = new Map<number, string>([
    [res.Update, 'Actualizar'],
    [res.SelectOrganization, 'Seleccione una organización'],
    [res.Loading, 'Cargando'],
    [res.LoadingInfo, 'Cargando Información'],
    [res.LoadingUserData, 'Cargando Información de Usuario'],
    [res.TitleDashboard, 'KPI ESTÁNDAR OPERATIVO'],
    [res.ActivityNotCreated, 'Actividad no creada'],
    [res.TitleClosing, 'Cierre'],
    [res.TitleOpening, 'Apertura'],
    [res.TitleCoordinator, 'Coordinador'],
    [res.CompletedDashboard, 'Completadas'],
    [res.StoresOf, 'Tiendas de'],
    [res.Stores, 'Tiendas'],
    [res.InventoryManagement, 'GESTIÓN DE INVENTARIOS'],
    [res.MerchandiseEntry, 'Ingreso Mercancía'],
    [res.Reception, 'Recepción'],
    [res.Income, 'Ingreso'],
    [res.CorporateTransfer, 'Traspaso Corporativo'],
    [res.Return, 'Devolución'],
    [res.Units, 'Unidades'],
    [res.Inventories, 'Inventarios'],
    [res.Differences, 'Diferencias'],
    [res.Pcs, 'Pzas'],
    [res.Cost, 'Costo'],
    [res.Execution, 'EJECUCIÓN'],
    [res.ChangeMarketingCampaign, 'Cambio de Nivel'],
    [res.ChangeMarketingCampaignUSA, 'Cambio de Nivel USA'],
    [res.UpdatePrices, 'Cambio de Precios'],
    [res.StoreType, 'Tipo Tienda'],
    [res.StoreLocation, 'Ubicación'],
    [res.Department, 'División'],
    [res.DetailType, 'Tipo Detalle'],
    [res.SelectItem, 'Selecciona un elemento'],
    [res.Campaign, 'Campaña'],
    [res.SupervisorZones, 'Zonas Supervisión'],
    [res.BrandDepartment, 'Marca División'],
    [res.BrandGender, 'Marca Género'],
    [res.CompletedComply, 'CUMPLIO'],
    [res.NotCompletedComply, 'NO CUMPLIO'],
    [res.VisualExecutiveZones, 'Zonas Ejecutivo Visual'],
    [res.VisualZones, 'Zonas Visual'],
    [res.AuditorZones, 'Zonas Auditor'],
    [res.TotalRating, 'Calificación Total'],
    [res.StoresVisited, 'Tiendas Visitadas'],
    [res.ByCategory, 'POR CATEGORÍA'],
    [res.ByRegion, 'POR REGIÓN'],
    [res.Zones, 'ZONAS'],
    [res.StoresMayus, 'TIENDAS'],
    [res.Name, 'Nombre'],
    [res.TransferredPieces, 'Piezas Traspasadas'],
    [res.Compliance, 'Cumplimiento'],
    [res.SupervisorName, 'Nombre Supervisor'],
    [res.TransferredPiecesAbbr, ' Pzas Traspasadas'],
    [res.CompositionTransfersMade, 'Composición de los traspasos realizados'],
    [res.Corporate, 'Corporativo'],
    [res.BetweenStores, 'Entre Tiendas'],
    [res.StoreName, 'Nombre Tienda'],
    [res.TopStoresGreaterPiecesTransferred, ' Top Tiendas mayor número de piezas traspasadas'],
    [res.ReturnedPieces, 'Piezas devueltas'],
    [res.ComplianceApprovedReturns, 'Cumplimiento Devoluciones Aprobadas'],
    [res.ReturnedPiecesAbbr, ' Pzas Devueltas'],
    [res.CompositionReturnsMade, 'Composición de las devoluciones realizados'],
    [res.TopStoresGreaterPiecesWithReturn, 'Top Tiendas mayor número de piezas con devolución'],
    [res.HistoricalChecklist, 'HISTÓRICO CHECKLIST'],
    [res.CurrentMonth, 'Mes Actual'],
    [res.AnnualAccumulated, 'Acumulado Anual'],
    [res.Day, 'Día'],
    [res.Month, 'Mes'],
    [res.MinComplianceAccepted, 'CUMPLIMIENTO MIN ACEPTADO'],
    [res.MadeInventories, 'Inventarios realizados'],
    [res.UnitDifferences, 'Diferencias unidades'],
    [res.CostDifferences, 'Diferencias costo'],
    [res.UnitsAbbr, 'Uds.'],
    [res.TransfersBetweenStores, 'Traspasos Entre Tiendas'],
    [res.Returns, 'Devoluciones'],
    [res.DifferencesByInventory, 'Diferencias por tipo inventario'],
    [res.InventoryBySupervisor, 'Inventario por supervisor'],
    [res.TopStoresGreaterNumberDifferences, 'Top tiendas mayor número de diferencias'],
    [res.TotalNumberInventoriesMonth, 'Número total inventarios al mes'],
    [res.InventoryType, 'Tipo inventario'],
    [res.Pieces, 'Piezas'],
    [res.NumberDifferences, 'Número diferencias'],
    [res.ActivitiesReport, 'Reporte de Actividades'],
    [res.Download, 'Descargar'],
    [res.DownloadChangeLevelInstruction, 'Instrucciones'],
    [res.ActivityType, 'Tipo Actividad'],
    [res.SelectAnOption, 'Seleccione una opción'],
    [res.NoAssignment, 'Sin asignación'],
    [res.Search, 'Buscar'],
    [res.Reference, 'Folio'],
    [res.ReferenceRequest, 'Referencia'],
    [res.ActivityName, 'Nombre Actividad'],
    [res.StartDate, 'Fecha Inicio'],
    [res.EndDate, 'Fecha Fin'],
    [res.Progress, 'Avance'],
    [res.Status, 'Estatus'],
    [res.ThereIsNoInformation, 'No hay información'],
    [res.Store, 'Tienda'],
    [res.ExecutionDate, 'Fecha Ejecución'],
    [res.Brand, 'Marca'],
    [res.NewActions, 'Nuevas Acciones'],
    [res.Section, 'Sección'],
    [res.Gender, 'Género'],
    [res.StyleVariety, 'Estilo Variedad'],
    [res.Description, 'Descripción'],
    [res.Price, 'Precio'],
    [res.CompletedDate, 'Fecha Completado'],
    [res.AlertSelectActivityFirst, 'Debe seleccionar un tipo de actividad primero.'],
    [res.LevelOneTab, 'Nivel 1 (Tab)'],
    [res.LevelOneTab, 'Nivel 2 (Card)'],
    [res.LevelThreeTitle, 'Nivel 3 (Titulo)'],
    [res.Instruction, 'Instrucción'],
    [res.Answer, 'Respuesta,'],
    [res.Comments, 'Comentarios'],
    [res.Photos, 'Fotos'],
    [res.Generating, 'Generando'],
    [res.AlertOperationCouldNotBeCompleted, 'No se pudo completar la operación'],
    [res.GettingImages, 'Obteniendo imágenes'],
    [res.FailedToGetImages, 'Error al obtener imágenes'],
    [res.Duration, 'Duración'],
    [res.Action, 'Acción'],
    [res.CommitmentDate, 'Fecha compromiso'],
    [res.GoBack, 'Regresar'],
    [res.ActivityScheduler, 'Programador de actividades'],
    [res.Consult, 'Consultar'],
    [res.Edit, 'Editar'],
    [res.Program, 'Programar'],
    [res.Activity, 'Actividad'],
    [res.Instructions, 'Instrucciones'],
    [res.Periodicity, 'Periodicidad'],
    [res.GettingChecklistList, 'Obteniendo listado de checklist'],
    [res.AlertSelectRecordPerformSelectedAction, 'Seleccione un registro para realizar la acción seleccionada'],
    [res.AlertUploadedFile, 'Archivo cargado'],
    [res.AlertNoUploadedFileFound, 'No se encontró archivo cargado'],
    [res.AlertSelectOnlyOneFile, 'Seleccione sólo un archivo'],
    [res.AlertOnlyPDFfilesAreAccepted, 'Sólo se aceptan archivos .PDF, seleccione otro archivo'],
    [res.AlertFileSizeExceedsAllowedWeight, 'El tamaño del archivo excede el peso permitido'],
    [res.File, 'Archivo'],
    [res.UploadedCorrectly, 'subido correctamente'],
    [res.AlertOnlyXlsxfilesAreAccepted, 'Solo se aceptan archivos .xlsx y .xls, seleccione otro archivo'],
    [res.Row, 'Renglón'],
    [res.EnterLevelName, 'Ingrese nombre de nivel'],
    [res.MinimumNumberPhotosMaximumNumberPhotos, 'Cantidad de fotos mínimas no puede ser mayor a la cantidad de fotos máximas'],
    [res.MinimumNumberPhotosCannotBeLesThan0, 'Cantidad de fotos mínimas no puede ser menor a 0'],
    [res.AlertSelectChecklistFunctionality, 'Seleccione una funcionalidad de checklist'],
    [res.AlertEnterTheTitleOfTheChecklist, 'Ingrese título del Checklist'],
    [res.AlertSelectCampaignFromChecklist, 'Seleccione campaña del checklist'],
    [res.AlertSelectOrganizationFromChecklist, 'Seleccione organización del checklist'],
    [res.AlertSelectPeriodicityOfTheChecklist, 'Seleccione periodicidad del checklist'],
    [res.AlertSelectOneStoreForTheChecklist, 'Seleccione al menos una tienda para el checklist'],
    [res.AlertSelectIfYouRequireNotice, 'Seleccione si requiere aviso'],
    [res.AlertSelectNoticeDate, 'Seleccione fecha de aviso'],
    [res.AlertSelectNoticeDocument, 'Seleccione un documento de aviso'],
    [res.AlertUploadFileWithNecessaryInstructions, 'Cargue el archivo con las instrucciones necesarias para la actividad'],
    [res.AlertCouldNotSaveChecklist, 'No se pudo guardar checklist'],
    [res.AlertCouldNotEditChecklist, 'No se pudo editar checklist'],
    [res.AlertEnterCampaignName, 'Ingrese nombre de campaña'],
    [res.AlertSelectStartDateDeadline, 'Seleccione fecha inicio y fecha límite'],
    [res.AlertCampaignCreatedSuccessfully, 'Campaña creada correctamente'],
    [res.AlertSelectCampaignToEdit, 'Seleccione campaña a editar'],
    [res.AlertSelectOrganization, 'Seleccione organización'],
    [res.AlertCampaignSuccessfullyEdited, 'Campaña editada correctamente'],
    [res.Save, 'Guardar'],
    [res.MandatoryInformation, 'Información obligatoria'],
    [res.GeneralData, 'Datos generales'],
    [res.ChecklistFunctionality, 'Funcionalidad checklist'],
    [res.AssignedStores, 'Tiendas asignadas'],
    [res.SeeStores, 'Ver tiendas'],
    [res.Title, 'Título'],
    [res.EnterTitle, 'Ingrese título'],
    [res.AddCampaign, 'Agregar Campaña'],
    [res.EditCampaign, 'Editar Campaña'],
    [res.Notice, 'Aviso'],
    [res.RequiresNotice, 'Requiere aviso'],
    [res.NoticeDate, 'Fecha aviso'],
    [res.NoticeAttachedDocument, 'Documento adjunto de aviso'],
    [res.SelectAFile, 'Seleccione un archivo'],
    [res.Choose, 'Elegir'],
    [res.RequiresReadingNotice, 'Requiere leer aviso antes de ejecutar'],
    [res.ActivityScheduling, 'Programación de actividad'],
    [res.Repeat, 'Repetir'],
    [res.Monday, 'Lunes'],
    [res.MondayAbbr, 'L'],
    [res.Tuesday, 'Martes'],
    [res.TuesdayAbbr, 'M'],
    [res.Wednesday, 'Miércoles'],
    [res.WednesdayAbbr, 'M'],
    [res.Thursday, 'Jueves'],
    [res.ThursdayAbbr, 'J'],
    [res.Friday, 'Viernes'],
    [res.FridayAbbr, 'V'],
    [res.Saturday, 'Sábado'],
    [res.SaturdayAbbr, 'S'],
    [res.Sunday, 'Domingo'],
    [res.SundayAbbr, 'D'],
    [res.LayoutDownload, 'Descarga de Layout'],
    [res.UploadInstructionsFile, 'Subir archivo de instrucciones'],
    [res.Detail, 'Detalle'],
    [res.MinimumImages, 'Imágenes Mínimas'],
    [res.MaximumImages, 'Imágenes Máximas'],
    [res.Answers, 'Respuestas'],
    [res.SelectStores, 'Seleccionar tiendas'],
    [res.Filters, 'Filtros'],
    [res.OpeningHours, 'Horario Apertura'],
    [res.ClosingHours, 'Horario Cierre'],
    [res.AllMayusA, 'TODAS'],
    [res.AllMayusO, 'TODOS'],
    [res.CheckUnchekAll, 'Marcar/Desmarcar todos'],
    [res.Accept, 'Aceptar'],
    [res.Deadline, 'Fecha Límite'],
    [res.Cancel, 'Cancelar'],
    [res.ValidityOfTheChecklist, 'Vigencia del checklist'],
    [res.RestrictChecklistHours, 'Restringir horario de checklist'],
    [res.RequiresMaxExecutionTime, 'Requiere hora máxima de ejecución'],
    [res.MaximumTimeRequired, 'Hora máxima requerida'],
    [res.LevelOne, 'Nivel 1'],
    [res.CaptureMayus, 'CAPTURA'],
    [res.Score, 'Puntaje'],
    [res.Message, 'Mensaje'],
    [res.TemplateManager, 'Administrador de Plantillas'],
    [res.Template, 'Plantilla'],
    [res.DownloadTemplate, 'Descargar Plantilla'],
    [res.Weighing, 'Ponderación'],
    [res.Actions, 'Acciones'],
    [res.RequiresTicket, 'Requiere Ticket'],
    [res.CorrectiveActionsPerStore, 'Acciones correctivas por tienda'],
    [res.End, 'Fin'],
    [res.ChecklistType, 'Tipo Checklist'],
    [res.Pending, 'Pendientes'],
    [res.Closed, 'Cerradas'],
    [res.NotPerformed, 'No realizadas'],
    [res.LastQualification, 'Últ. Calificación'],
    [res.Evaluator, 'Evaluador'],
    [res.LastEvaluation, 'Últ. Evaluación'],
    [res.YouMustConsultInforFirst, 'Debe consultar información primero'],
    [res.CorrectiveActionsDetail, 'Detalle Acciones Correctivas'],
    [res.Responsable, 'Responsable'],
    [res.RequiredDate, 'Fecha Requerida'],
    [res.SolutionDate, 'Fecha Solución'],
    [res.CorrectiveAction, 'Acción Correctiva'],
    [res.Close, 'Cerrar'],
    [res.View, 'Ver'],
    [res.StoresReport, 'Reporte de Tiendas'],
    [res.StoresReportChecklist, 'Reporte de Tiendas Visual'],
    [res.CumulativeTotal, 'Total Acumulado'],
    [res.StoreOpeningChecklist, 'Checklist Apertura'],
    [res.StoreClosingChecklist, 'Checklist Cierre'],
    [res.StoreOpeningChecklistUSA, 'Checklist Apertura USA'],
    [res.StoreClosingChecklistUSA, 'Checklist Cierre USA'],
    [res.SupervisorChecklist, 'Checklist Supervisor'],
    [res.SupervisorChecklistUSA, 'Checklist Supervisor USA'],
    [res.VIMChecklist, 'Checklist VIM'],
    [res.CorrectiveActions, 'Acciones Correctivas'],
    [res.AlertNoInfoToDownload, 'No hay información para descargar'],
    [res.AlertTheStartDateCannotBeHigher, 'La fecha de inicio no puede ser superior a la fecha fin'],
    [res.CompliancePercentage, 'Porcentaje de cumplimiento'],
    [res.CompositionPercentage, 'Porcentaje Composición'],
    [res.PercentageSent, 'Porcentaje Enviado'],
    [res.PercentageReceived, 'Porcentaje Recibido'],
    [res.AlertCannotGenerateReport, 'No se puede generar reporte'],
    [res.VisualMerchandiserChecklist, 'Checklist Visual'],
    [res.VisualMerchandiserChecklistUSA, 'Checklist Visual USA'],
    [res.AuditorChecklist, 'Checklist Auditor'],
    [res.AuditorChecklistUSA, 'Checklist Auditor USA'],
    [res.CoordinatorChecklist, 'Checklist Coordinador'],
    [res.CoordinatorChecklistUSA, 'Checklist Coordinador USA'],
    [res.ReturnToProvider, 'Devolución a Proveedor'],
    [res.PhysicalInventory, 'Inventario Físico'],
    [res.ScheduleActivities, 'Programar Actividades'],
    [res.Receptions, 'Recepciones'],
    [res.Incomes, 'Ingresos'],
    [res.StoreTransfers, 'Traspasos Tienda'],
    [res.ReturnsRequests, 'Solicitudes de Devoluciones por Defecto'],
    [res.ManageStores, 'Administrar Tiendas'],
    [res.ManageDevicesAbbr, 'Admin. Dispositivos'],
    [res.OrganizationalStructure, 'Admin. Tiendas por usuario'],
    [res.ManageEmployeesAbbr, 'Admin. Empleados'],
    [res.ManageZonesAbbr, 'Admin. Zonas'],
    [res.Indicators, 'Indicadores'],
    [res.Operation, 'Operación'],
    [res.Inventory, 'Inventario'],
    [res.Configuration, 'Configuración'],
    [res.LogOut, 'Cerrar Sesión'],
    [res.CEDISMerchandiseEntry, 'Ingreso de Mercancía CEDIS'],
    [res.ASNMerchandiseEntry, 'Ingreso de Mercancía ASN'],
    [res.SelectStore, 'Seleccionar Tienda'],
    [res.Delivery, 'Entrega'],
    [res.SendDate, 'Fecha envío'],
    [res.Received, 'Recibido'],
    [res.Entry, 'Ingresado'],
    [res.MerchandiseDetail, 'Detalle mercancía'],
    [res.ShippingNumberDetail, 'Detalle talones'],
    [res.FinishedA, 'Terminada'],
    [res.Process, 'Proceso'],
    [res.AlertNoDeliveryInfoWasObtained, 'No se obtuvo información de entrega'],
    [res.TransportStartDateMayus, 'FECHA INICIO TRANSPORTE'],
    [res.ShippingNumberIncludedMayus, 'TALONES INCLUIDOS'],
    [res.ShippingNumberReceivedMayus, 'TALONES RECIBIDOS'],
    [res.ShippingNumberReceivedByASNMayus, 'TALONES RECIBIDOS POR ASN'],
    [res.ShippingNumberReceivedWithoutASNMayus, 'TALONES RECIBIDOS SIN ASN'],
    [res.ShippingNumber, 'No. Código Talón'],
    [res.Date, 'Fecha'],
    [res.Hour, 'Hora'],
    [res.ReceivedBy, 'Recibido Por'],
    [res.ReferenceReception, 'Folio Recepción'],
    [res.CancelShippingNumber, 'Cancelar talón'],
    [res.YouReallyWantCancelShippingNumber, '¿Realmente deseas cancelar este talón?'],
    [res.Yes, 'Si'],
    [res.Not, 'No'],
    [res.ShippingNumberReceived, 'Talones recibidos'],
    [res.ShippingNumberReceivedByASN, 'Talones recibidos por ASN'],
    [res.ShippingNumberReceivedWithoutASN, 'Talones recibidos sin ASN'],
    [res.ViewComments, 'Ver comentarios'],
    [res.ViewPhotos, 'Ver fotos'],
    [res.AlertErrorGettingInformation, 'Error obteniendo la información'],
    [res.MerchandiseTotalToEntryMayus, 'TOTAL MERCANCÍA ENVIADA'],
    [res.MerchandiseEntryMayus, 'TOTAL MERCANCÍA RECIBIDA'],
    [res.MissingMerchandiseMayus, 'TOTAL DIFERENCIAS'],
    [res.Style, 'Estilo'],
    [res.Variety, 'Variedad'],
    [res.Size, 'Talla'],
    [res.EntryBy, 'Ingresado por'],
    [res.EntryDate, 'Fecha ingreso'],
    [res.EntryReference, 'Folio ingreso'],
    [res.AlertErrorGettingCatalogs, 'Error obteniendo catálogos'],
    [res.ReceptionReport, 'Reporte de Recepciones'],
    [res.Employee, 'Empleado'],
    [res.Confirmation, 'Confirmación'],
    [res.CreateInventory, 'Crear Inventario'],
    [res.CreatedBy, 'Creado por'],
    [res.InventoryReference, 'Folio Inventario'],
    [res.Counting, 'Conteo'],
    [res.StockTPV, 'Existencias TPV'],
    [res.Tags, 'Marbetes'],
    [res.Unsubscribe, 'Dar de baja'],
    [res.Export, 'Exportar'],
    [res.AlertStoresCouldNotBeObtained, 'No se pudieron obtener las tiendas'],
    [res.AlertOrganizationsCouldNotBeObtained, 'No se pudieron obtener las organizaciones'],
    [res.AlertInventoriesCouldNotBeObtained, 'No se pudieron obtener los inventarios'],
    [res.AlertTitlesCouldNotBeObtained, 'No se pudieron obtener los títulos'],
    [res.AlertYouDoNotHaveThePermissionsToCreate, 'No tienes los permisos para crear'],
    [res.AlertYouDoNotHaveThePermissionsToEdit, 'No tienes los permisos para editar'],
    [res.AlertYouDoNotHaveThePermissionsToRemoveInventory, 'No tienes los permisos para dar de baja el inventario'],
    [res.AlertThisInventoryDoesNotHaveCapturedData, 'Este inventario no cuenta con datos capturados'],
    [res.AlertThereWasErrorConsultingDetailInventory, 'Hubo un error al consultar el detalle de este inventario'],
    [res.AlertInventoryDataCouldNotBeObtained, 'No se pudieron obtener los datos del inventario'],
    [res.AlertCantDeleteInventory, 'No se puede borrar el inventario'],
    [res.Delete, 'Borrar'],
    [res.Product, 'Producto'],
    [res.CountingQuantity, 'Cantidad conteo'],
    [res.User, 'Usuario'],
    [res.Profile, 'Perfil'],
    [res.Scanned, 'Escaneado'],
    [res.AlertTheDataHasBeenUpdatedSuccessfully, 'Se han actualizado los datos correctamente'],
    [res.AlertInfoMustBeLoadedToGenerateTheFile, 'Se debe de cargar información en la tabla para poder generar el archivo'],
    [res.Quantity, 'Cantidad'],
    [res.EditInventory, 'Editar inventario'],
    [res.SAPpiecesQuantity, 'Cantidad de piezas de SAP'],
    [res.CreateFilter, 'Crear filtro'],
    [res.CreateTags, 'Crear marbetes'],
    [res.AddAtag, 'Agregar un marbete'],
    [res.AddTags, 'Agregar marbetes'],
    [res.ReferenceTag, 'Folio marbete'],
    [res.TagName, 'Nombre marbete"'],
    [res.PrintTag, 'Imprimir marbete'],
    [res.PrintAllTags, 'Imprimir todos los marbetes'],
    [res.EnterNumberPieces, 'Ingrese # piezas'],
    [res.TagReference, 'Folio marbete'],
    [res.AlertInventoryTypesCouldNotBeObtained, 'No se pudieron obtener los tipos de inventarios'],
    [res.AlertBrandsCouldNotBeObtained, 'No se pudieron obtener las marcas,'],
    [res.GettingTheStores, 'Obteniendo las tiendas'],
    [res.GettingOrganizations, 'Obteniendo las organizaciones'],
    [res.ObtainingTheTypesOfInventories, 'Obteniendo los tipos de inventarios'],
    [res.ObtainingTheBrands, 'Obteniendo las marcas'],
    [res.GettingDepartments, 'Obteniendo divisiones'],
    [res.AlertDepartmentsCouldNotBeObtained, 'No se pudieron obtener los departamentos'],
    [res.GettingGenders, 'Obteniendo géneros'],
    [res.AlertGendersCouldNotBeObtained, 'No se pudieron obtener los generos'],
    [res.AlertFilterCombinationCannotBeRepeated, 'La combinación del filtro no se puede repetir'],
    [res.AlertYouMustSelectTheBrand, 'Debes seleccionar la marca'],
    [res.AlertYouMustSelectTheDepartment, 'Debes seleccionar la división'],
    [res.AlertYouMustSelectTheGender, 'Debes seleccionar el género'],
    [res.AlertYouMustSelectTheTypeInventory, 'Debes seleccionar el tipo de inventario'],
    [res.AlertYouMustSelectTheStore, 'Debes seleccionar la tienda'],
    [res.AlertNumberTagsMustBegreater, 'El número de marbetes debe ser mayor a 0'],
    [res.AlertYouMustGenerateTheTags, 'Debes generar los marbetes'],
    [res.AlertYouMustGenerateAtLeastOneFilter, 'Debes generar al menos un filtro'],
    [res.GeneratingFilter, 'Generando filtro'],
    [res.GeneratingTags, 'Generando marbetes'],
    [res.Tag, 'Marbete'],
    [res.AlertCouldNotGetTheNextInventoryNumber, 'No se pudo obtener el siguiente número de inventario para la tienda'],
    [res.AlertYouMustHaveAtLeastOneTag, 'Debes tener al menos un marbete'],
    [res.GeneratingInventory, 'Generando inventario'],
    [res.AlertUnableSaveInventoryForTheStore, 'No se pudo guardar el inventario para la tienda'],
    [res.AlertYouDoNotHavePermissionsToPerformThisAction, 'No cuenta con permisos para realizar esta acción'],
    [res.Validation, 'Validación'],
    [res.Scanning, 'Escaneo'],
    [res.AlertYouMustCreateTheTagsBeforePrintingThem, 'Debes de crear los marbetes antes de imprimirlos'],
    [res.AddingTag, 'Agregando marbete'],
    [res.AlertTheTagCouldNotBeAdded, 'No se pudo agregar el marbete'],
    [res.RemovingTag, 'Eliminando marbete'],
    [res.TagCouldNotBeDeleted, 'No se pudo borrar marbete'],
    [res.generatePDF, 'Generar PDF'],
    [res.errorMessageGeneratePDF, 'Hubo un error al conectarse a la impresora, contacta a soporte técnico. ¿Deseas generar el PDF para imprimir manualmente?'],

    [res.SupplierReturnsRequests, 'Solicitudes de Devoluciones a Proveedor'],
    [res.OriginStore, 'Tienda origen'],
    [res.RequestReference, 'Folio Solicitud'],
    [res.Reason, 'Motivo'],
    [res.RequestedQuantity, 'Cantidad Solicitada'],
    [res.Shipment, 'Envío'],
    [res.Society, 'Sociedad'],
    [res.Invoice, 'Factura'],
    [res.RequestDate, 'Fecha Solicitud'],
    [res.ApprovalDate, 'Fecha Aprobación'],
    [res.LastShipmentDate, 'Fecha Último Envío'],
    [res.GettingReturnsRequests, 'Obteniendo solicitudes de devoluciones'],
    [res.AlertTheReturnRequestListCouldNotBeObtained, 'No se pudo obtener el listado de solicitudes de devoluciones'],
    [res.AletStoreListCouldNotBeObtained, 'No se pudo obtener el listado de tiendas'],
    [res.ObtainingReturnReasons, 'Obteniendo motivos de devolución'],
    [res.AlertReturnReasonsCouldNotBeObtained, 'No se pudieron obtener los motivos de devolución'],
    [res.AlertStoreListCouldNotBeObtained, 'No se pudo obtener el listado de tiendas'],
    [res.Approved, 'Aprobada'],
    [res.PendingRet, 'Pendiente'],
    [res.ReturnRequest, 'Solicitud Devolución'],
    [res.Approve, 'Aprobar'],
    [res.ReasonForReturn, 'Motivo devolución'],
    [res.Requested, 'Solicitado'],
    [res.Approval, 'Aprobación'],
    [res.ApprovedQuantity, 'Cantidad Aprobada'],
    [res.Sent, 'Enviado'],
    [res.AlertCouldNotGetTheRequestDetail, 'No se pudo obtener el detalle de la solicitud'],
    [res.SavingInformation, 'Guardando información'],
    [res.ReturnsToSupplier, 'Devoluciones a Proveedor'],
    [res.StoreReturnReference, 'Folio Devolución Tienda'],
    [res.ObtainingReturnsToSupplier, 'Obteniendo devoluciones a proveedor'],
    [res.AlertReturnsToSupplierCouldNotBeObtained, 'No se pudo obtener el listado de devoluciones a proveedor'],
    [res.ShippingType, 'Tipo de envío'],
    [res.AmountSent, 'Cantidad Enviada'],
    [res.AlertReturnDetailCouldNotBeObtained, 'No se pudo obtener el detalle de la devolución'],
    [res.DownloadReport, 'Descargar Reporte'],
    [res.RequestTransfer, 'Solicitar Traspaso'],
    [res.DownloadLayout, 'Descargar Layout'],
    [res.DestinationStore, 'Tienda destino'],
    [res.TransferReference, 'Folio traspaso'],

    [res.TransferStoreEntry, 'Folio ingreso'],
    [res.EmployeeRecibedEntry, 'Empleado que recibe'],
    [res.EmployeeConfirmedEntry, 'Empleado de confirmación'],
    [res.ReceivedDate, 'Fecha recepción'],
    [res.ArticlesEntered, 'Articulos ingresados'],
    [res.FolioTransferEntryTitle, 'Folio ingreso'],
    [res.FoliosTransferEntryTitle, 'Folios de ingreso'],

    [res.ObtainingTheCorporateTransfers, 'Obteniendo los traspasos corporativos'],
    [res.AlertCorporateTransfersCouldNotBeObtained, 'No se pudieron obtener los traspasos corporativos'],
    [res.GettingTheSectors, 'Getting the sectors'],
    [res.GettingTheWeeks, 'Obteniendo semanas'],
    [res.AlertCouldNotGetTheSectors, 'No se pudieron obtener los sectores'],
    [res.AlertYouMustFillTheFieldsOfTheForm, 'Debes de llenar todos los campos del formulario'],
    [res.SavingData, 'Guardando datos'],
    [res.DeletingTransfer, 'Eliminando transferencia'],
    [res.AlertHasBeenRemovedSuccessfully, 'Se ha eliminado con éxito'],
    [res.RequestNewTransfer, 'Solicitar nuevo traspaso'],
    [res.Week, 'Semana'],
    [res.Year, 'Año'],
    [res.Organization, 'Organización'],
    [res.OrganizationImgCollectorAdd, 'Organización a asignar'],
    [res.UploadTransferFile, 'Subir archivo de traspasos'],
    [res.ContinueSaving, 'Continuar guardando'],
    [res.Transfer, 'Traspaso'],
    [res.Origin, 'Origen'],
    [res.Destination, 'Destino'],
    [res.CorporateDateRequested, 'Fecha solicitud corporativo'],
    [res.Season, 'Temporada'],
    [res.Rejected, 'Rechazado'],
    [res.RejectedQuantity, 'Cantidad Rechazada'],
    [res.AlertTheTransfersCouldNotBeObtained, 'No se pudieron obtener los traspasos'],
    [res.AddStore, 'Agregar Tienda'],
    [res.Country, 'País'],
    [res.CountryOperation, 'País Operación'],
    [res.Active, 'Activa'],
    [res.Inactive, 'Inactiva'],
    [res.ParticipateQuantum, 'Participa Quantum'],
    [res.MigradaNEModal, 'Migrar a Nuevo Esquema'],
    [res.RequierePaqueteria, 'Requiere Paqueteria'],
    [res.ReasonForClosure, 'Motivo de cierre'],
    [res.ReopeningDate, 'Fecha reapertura'],
    [res.Continue, 'Continuar'],
    [res.ActivateStore, 'Activar tienda'],
    [res.StoreWillBeActivated, 'Se activará la tienda {0} ¿Desea continuar?'],
    [res.DesactivateStore, 'Desactivar tienda'],
    [res.AreYouSureToDeactivateStore, '¿Está seguro de desactivar la tienda {0}?'],
    [res.ParticipationQuantumWillBeActivated, 'Se activará participación en Quantum para la tienda {0} ¿Desea continuar?'],
    [res.RemoveParticipateQuantum, 'Quitar Participa Quantum'],
    [res.AreyouSureToDisableQuantumEngagement, '¿Está seguro de desactivar participación en Quantum para la tienda {0}?'],
    [res.AreyouSureToActivatedMigradaNE, '¿Está seguro de Migrar al Nuevo Esquema la tienda {0} ? '],
    [res.AreyouSureToActivatedReqPaqueteria, '¿Está seguro de activar Requiere Paqueteria para la tienda {0} ? '],
    [res.AreyouSureToDisableMigradaNE, '¿Está seguro en desactivar la Migración al Nuevo Esquema de la tienda {0} ?'],
    [res.AreyouSureToDisableReqPaqueteria, '¿Está seguro de desactivar Requiere Paqueteria para la tienda {0}?'],
    [res.AlertSelectClosingReason, 'Seleccione motivo de cierre'],
    [res.AlertSelectReopeningDate, 'Seleccione fecha reapertura'],
    [res.AlertStoreSuccessfullyUpdated, 'Tienda actualizada correctamente'],
    [res.MasterData, 'Datos Maestros'],
    [res.BranchPlan, 'Plano de sucursal'],
    [res.Attach, 'Adjuntar'],
    [res.StoreNumberAbbr, 'No. Tienda'],
    [res.ActiveStore, 'Tienda Activa'],
    [res.BrandType, 'Tipo de Marca'],
    [res.Zone, 'Zona'],
    [res.Address, 'Dirección'],
    [res.ExteriorNumber, 'Número Exterior'],
    [res.InteriorNumber, 'Número Interior'],
    [res.Suburb, 'Colonia'],
    [res.City, 'Ciudad'],
    [res.State, 'Estado'],
    [res.PostalCode, 'Código Postal'],
    [res.Phone, 'Teléfono'],
    [res.Mail, 'Correo electrónico'],
    [res.LatitudeCoordinate, 'Coordenada Latitud'],
    [res.LengthCoordinate, 'Coordinada Longitud'],
    [res.SellingMeters, 'Metros de Venta'],
    [res.TotalMeters, 'Metros Totales'],
    [res.Capacity, 'Capacidad'],
    [res.OpeningDate, 'Fecha Apertura'],
    [res.CoordinatorRegion, 'Región Coordinador'],
    [res.SupervisorZone, 'Zona Supervisor'],
    [res.VIMZone, 'Zona VIM'],
    [res.ExecutiveZone, 'Ejecutivo Visual'],
    [res.Coordinator, 'Coordinador'],
    [res.Of, 'De'],
    [res.To, 'A'],
    [res.ScheduledReopeningDate, 'Fecha reapertura programada'],
    [res.StoreClosure, 'Cierre de tienda'],
    [res.ClosingDate, 'Fecha cierre'],
    [res.Schedules, 'Horarios'],
    [res.ObtainingStoreData, 'Obteniendo datos de tienda'],
    [res.GettingStoreHours, 'Obteniendo horarios de tienda'],
    [res.ObtainingClosureReasons, 'Obteniendo motivos de cierre'],
    [res.ObtainingListOfCountries, 'Obteniendo listado de países'],
    [res.ObtainingListOfBrands, 'Obteniendo listado de marcas'],
    [res.ObtainingListOfOrganizations, 'Obteniendo listado de organizaciones'],
    [res.GettingListOfStoreTypes, 'Obteniendo lista de tipos de tienda'],
    [res.GettingListOfStoreLocations, 'Obteniendo lista de ubicaciones de tienda'],
    [res.GettingListOfZones, 'Obteniendo lista de zonas'],
    [res.EnterStoreNumber, 'Ingrese No. Tienda'],
    [res.ChangesHaveBeenSavedSuccessfully, 'Se han guardado los cambios con éxito'],
    [res.ErrorSavingTryAgain, 'Error guardando. Intente de nuevo.'],
    [res.OpeningHoursAreIncorrect, 'El horario de apertura del {0} es incorrecto'],
    [res.ClosingTimeIsIncorrect, 'El horario de cierre del {0} es incorrecto'],
    [res.EnterStoreName, 'Ingrese nombre de tienda'],
    [res.SelectCountry, 'Seleccione país'],
    [res.SelectStoreType, 'Seleccione Tipo de Tienda'],
    [res.SelectStoreLocation, 'Seleccione Ubicación de Tienda'],
    [res.SelectBrandType, 'Seleccione Tipo de Marca'],
    [res.SelectZone, 'Seleccione Zona'],
    [res.LatitudeMustBeEqual, 'Latitud debe ser igual o mayor a -90 y menor o igual a 90'],
    [res.LengthMustBeEqual, 'Longitud debe ser igual o mayor a -180 y menor o igual a 180'],
    [res.SelectStoreClosingReason, 'Seleccione motivo de cierre de tienda'],
    [res.SelectScheduledReopeningDate, 'Seleccione fecha de reapertura programada'],
    [res.SelectClosingDate, 'Seleccione fecha de cierre'],
    [res.BlueprintNotBeenUploaded, 'No se ha subido un plano para esta tienda.'],
    [res.Consignee, 'Consignatario'],
    [res.CostCenter, 'Centro de Costos'],
    [res.HumanTalentExecutive, 'Ejecutivo Talento Humano'],
    [res.Contract, 'Contrato'],
    [res.ContractSignatureDate, 'Fecha Firma de Contrato'],
    [res.SquareMetersContract, 'Metros Cuadrados Contrato'],
    [res.Expansion, 'Expansión'],
    [res.TotalSquareMeters, 'Metros Cuadrados Totales'],
    [res.SquareMetersSaleFloor, 'Metros Cuadrados Piso de Venta'],
    [res.SquareMetersMezzanine, 'Metros Cuadrados Mezzanine'],
    [res.SquareMetersWarehouse, 'Metros Cuadrados Bodega'],
    [res.EnterValidNumberConsigneeField, 'Escriba un número válido en el campo consignatario'],

    [res.ServiceUrl, 'URL de servicio'],
    [res.Devices, 'Dispositivos'],
    [res.SerialCode, 'Código Serial'],
    [res.Identifier, 'Identificador'],
    [res.Model, 'Modelo'],
    [res.AssignedStore, 'Tienda Asignada'],
    [res.CurrentStore, 'Tienda Actual'],
    [res.LastOnlineEvent, 'Último Evento Online'],
    [res.APKVersion, 'Versión APK'],
    [res.Unassigned, 'Sin Asignar'],
    [res.GettingStoreDevices, 'Obteniendo dispositivos de tienda'],
    [res.ManageDevices, 'Administración de Dispositivos'],
    [res.Add, 'Añadir'],
    [res.DeviceType, 'Tipo Dispositivo'],
    [res.GettingDeviceList, 'Obteniendo listado de dispositivos'],
    [res.AddDevice, 'Agregar Dispositivo'],
    [res.EditDevice, 'Editar Dispositivo'],
    [res.SelectARecordToEdit, 'Seleccione un registro para editar'],
    [res.DeviceRegisteredSuccessfully, 'Dispositivo registrado correctamente'],
    [res.DeviceEditedSuccessfully, 'Dispositivo editado correctamente'],
    [res.FillInAllTheFieldsMarked, 'Llene todos los campos marcados con'],
    [res.SelectStoreToWhichTheDeviceAssigned, 'Seleccione tienda a la que se le asignará el dispositivo'],
    [res.StoreManagementByUser, 'Administración de tiendas por usuario'],
    [res.Position, 'Puesto'],
    [res.TheOrganizationChartCouldNotBeDisplayed, 'No se pudo visualizar el organigrama'],
    [res.DeletingUser, 'Eliminando usuario'],
    [res.CouldNotDeleteThisUser, 'No se pudo eliminar este usuario'],
    [res.Validating, 'Validando'],
    [res.AllO, 'Todos'],
    [res.None, 'Ninguno'],
    [res.AddEmployee, 'Agregar empleado'],
    [res.SaveEmployee, 'Guardar empleado'],
    [res.EditEmployee, 'Editar empleado'],
    [res.SaveChanges, 'Guardar cambios'],
    [res.PositionsWereNotObtained, 'No se obtuvieron los puestos'],
    [res.CountriesWereNotObtained, 'No se obtuvieron los países'],
    [res.ThereWasAnErrorGettingTheStores, 'Hubo un error obteniendo las tiendas'],
    [res.InvalidEmail, 'Email no válido'],
    [res.MissingAddEmail, 'Falta agregar el email'],
    [res.SomeFieldsAreMissing, 'Faltan algunos campos. Favor de verificar'],
    [res.ThePlaceWasNotSaved, 'No se guardó la plaza'],
    [res.ThePlaceWasNotUpdated, 'No se actualizo la plaza. Intenta de nuevo'],
    [res.EmployeeName, 'Nombre empleado'],
    [res.CleanData, 'Limpiar Datos'],
    [res.AllStores, 'Todas las tiendas'],
    [res.Employees, 'Empleados'],
    [res.RegisterEmployee, 'Registrar empleado'],
    [res.EmployeeNumber, 'Número Empleado'],
    [res.Email, 'Correo Electrónico'],
    [res.EmployeeDetail, 'Detalle de Empleado'],
    [res.CouldNotGetTheZones, 'No se pudieron obtener las zonas'],
    [res.ItIsNotPossibleToDeleteAnAreaWithAssignedStores, 'No es posible eliminar zona con tiendas asignadas. Verifique e intente nuevamente.'],
    [res.AreYouSureToDeleteTheZone, '¿Está seguro de eliminar la zona?'],
    [res.GettingRegions, 'Obteniendo regiones'],
    [res.CouldNotGetTheRegions, 'No se pudieron obtener las regiones'],
    [res.InvalidZoneName, 'Nombre de zona no válido'],
    [res.CantSave, 'No es posible guardar'],
    [res.SelectRegion, 'Seleccione la región'],
    [res.ZoneCreatedSuccessfully, 'Zona creada correctamente'],
    [res.ZoneEditedSuccessfully, 'Zona editada correctamente'],
    [res.ZoneDeletedSuccessfully, 'Zona eliminada correctamente'],
    [res.ManageZones, 'Administrar Zonas'],
    [res.AddZone, 'Agregar zona'],
    [res.EditZone, 'Editar Zona'],
    [res.StoresAvailable, 'Tiendas disponibles'],
    [res.DeleteZone, 'Eliminar zona'],
    [res.Summary, 'Resumen'],
    [res.TotalStocksTPV, 'Total Existencias TPV'],
    [res.TotalScannedQuantum, 'Total Quantum Escaneado'],
    [res.TotalDifferences, 'Total De Diferencias'],

    // Admin Modules
    [res.ManageModulesMenu, 'Admin. Módulos'],
    [res.ManageModulesTitle, 'Administrar Módulos'],
    [res.ManageModulesRowName, 'Nombre'],
    [res.ManageModulesRowStores, 'Tiendas con módulo deshabilitado'],
    [res.ManageModulesSuccessMessage, 'Se han guardado con éxito los cambios.'],

    // InventoryDetail
    [res.TitleInventoryFilters, 'Filtros del Inventario'],
    [res.TitleScannedProductSummary, 'Resumen de productos escaneados'],
    [res.TitleScansPerformedByProduct, 'Reporte de lecturas realizadas durante el escaneo'],
    [res.TitleDiferencesReportStyleVariety, 'Reporte de diferencias por estilo variedad'],
    [res.QuantumScanned, 'Quantum Escaneado'],
    [res.StocksTPV, 'Existencias TPV'],

    // StoreReport
    [res.Checklist, 'Checklist'],

    // Activities Schedule
    [res.SelectStatus, 'Selecciona un estatus'],
    [res.Consigment, 'Traspasos en Transito'],
    [res.DateTransfer, 'Fecha de Traspaso'],
    [res.DateTransite, 'Dias en transito'],
    [res.Red, 'Rojo'],
    [res.Yellow, 'Amarillo'],
    [res.Green, 'Verde'],
    [res.SelectStatus, 'Selecciona un estatus'],

    // Admin Tienda
    [res.Society, 'Sociedad'],
    [res.CcPayRoll, 'Centro de costos (Nomina)'],
    [res.WareHouse, 'Almacén'],
    [res.Sap, 'SAP'],
    [res.StoreCode, 'Código de tienda'],

    // InventoryCount Create/Detail
    [res.AlertOrganizationInfoCouldNotBeObtained, 'No se pudo obtener información de la organización'],
    [res.AlertConfigurationInfoCouldNotBeObtained, 'No se pudo obtener información de organización con idioma ingles'],
    [res.GettingOrganization, 'Obteniendo información de organización'],
    [res.GettingEnglishOrganization, 'Obteniendo organizaciones con idioma en inglés'],
    [res.PrintingTags, 'Imprimiendo Marbetes'],
    [res.DeleteInventory, 'Eliminar Inventario'],
    [res.MessageDeleteInvetory, '¿Desea dar de baja el inventario '],

    // InventoryCount
    [res.InventoryDeletedSuccessfully, 'Inventario eliminado con éxito.'],

    [res.Import, 'Importar'],
    [res.ImportFile, 'Importar Archivo'],
    [res.IncorrectLayout, 'Layout Incorrecto'],
    [res.Restock, 'Resurtibles'],
    [res.RestockChampions, 'Campeones Resurtibles'],
    [res.ReinforceCentralSizes, 'Refuerzo Tallas Centrales'],
    [res.NewBasics, 'Nuevos Básicos'],
    [res.RestockSave, 'Estrategia guardada correctamente'],
    [res.RestockStatus, 'No es posible guardar los resurtibles, revisa sus estatus...'],
    [res.Stock, 'Stock'],
    [res.Sell, 'Vendidas'],
    [res.RestockReport, 'Reporte Resurtibles'],
    [res.UnitsDetail, 'Detalle unidades'],
    [res.CR, 'CR'],
    [res.NB, 'NB'],
    [res.RTC, 'RTC'],
    [res.Strategy, 'Estrategia'],

    // Pre-ironed - InventoryCount
    [res.PreIroned, 'Pre-planchado'],
    [res.TheoreticalFile, 'Archivo teórico'],
    [res.ChargeEntry, 'Entrada de cargo'],
    [res.Sales, 'Venta'],
    [res.WareEntry, 'Ingreso de mercancía'],
    [res.EndingTheoreticalInventory, 'Inventario teórico final'],
    [res.Concept, 'Concepto'],
    [res.TitleInfo, 'Información'],
    [res.Total, 'Total'],
    [res.GenerateDetail, 'Generar detalle'],
    [res.SKU, 'SKU'],
    [res.Completed, 'Completado'],
    [res.WithError, 'No procesado'],
    [res.WithoutProcess, 'Sin procesar'],
    [res.FileTypeNoSupported, 'Tipo de archivo no soportado'],
    [res.Physical, 'Físico'],

    // Image Collector
    [res.ImageCollector, 'Coleccionador de imágenes'],
    [res.CreateImageCollector, 'Nueva imagen'],
    [res.Module, 'Módulo'],
    [res.ModuleImgCollectorAdd, 'Módulo a asignar'],
    [res.MSGInvalidFormat, 'Formato invalido'],
    [res.AlertOnlyImgfilesAreAccepted, 'Solo archivos de imágen son válidos'],
    [res.AlertCouldNotSaveImageCollector, 'No fue posible guardar la imágen'],
    [res.AlertCouldNotSaveImageCollectorLogIn, 'No debe existir una organización seleccionada para el módulo seleccionado.'],
    [res.AlertCouldNotSaveImageCollectorCmbModuleNotSelected, 'Debe seleccionar un módulo.'],
    [res.AlertCouldNotSaveImageCollectorCmbOrganizationNotSelected, 'Debe seleccionar una organización.'],
    [res.AlertCouldNotSaveImageCollectorImgNotLoaded, 'Debe cargar una imágen.'],
    [res.AlertCouldNotLoadImage, 'No fue posible cargar la imágen.'],
    [res.CreateImage, 'Crear Imagen'],
    [res.Activate, 'Activar'],
    [res.ActivateImage, 'Activar imágen'],
    [res.ImageWillBeActivated, '¿Desea activar la imágen?.'],
    [res.SaveImageConfirmationAllOrganizations, '¿Desea activar la imágen para el módulo {0} en todas las organizaciones?.'],
    [res.SaveImageConfirmation, '¿Desea activar la imágen para el módulo {0} en la organización {1}?.'],
    [res.SaveImage, 'Guardar imágen'],
    [res.ImageCollectorUpdateSuccessfully, 'Imágen activada exitosamente.'],
    [res.ImageCollectorSaveSuccessfully, 'Imágen guardada exitosamente.'],

    // Upload Image
    [res.DragnDrop, 'Arrastra y suelta la imagen aquí'],
    [res.Or, 'ó'],
    [res.BrowseForFile, 'Busca archivo'],

    // Tenant
    [res.Tenant, 'Tenant'],
    [res.AlertThisUserDoesNotBelongATenantAvailable, 'Este usuario no pertenece a un Tenant disponible'],
    [res.AlertThereWasErrorConsultingTenant, 'Hubo un error consultando los Tenant'],
    [res.AlertTenantDataCouldNotBeObtained, 'No pudo obtenerse información de Tenant'],
    [res.TenantNotAvailable, 'Tenant no disponible'],
    [res.CouldNotGetTenant, 'No fue posible obtener el tenant'],

    // Organization
    [res.CouldNotGetOrganizations, 'No fue posible obtener las organizaciones'],
    [res.AvailableOrganizations, 'Organizaciones disponibles'],
    [res.OrganizationStores, 'Tiendas de Organización'],
    [res.Tenant, 'Tenant'],
    [res.MigradaNE, 'Migrada N.E.'],
    [res.ReqPackage, 'Req. Paqueteria'],

    // Admin Zones
    [res.Region, 'Región'],

    // Transfer Request
    [res.AlertTransfersCouldNotBeObtained, 'No fue posible obtener los traspasos'],
    [res.ErrorTransferSector, '<div>Los siguientes registros contienen un sector no válido: </div>'],
    [res.ErrorTransferStoreNotOnlyMigrated, '<div>Contener tiendas migradas y no migradas a nuevo esquema de operación no es permitido.</div>'],
    [res.ErrorTransferStoreOrganization, '<div>Las siguientes tiendas no son pertenecientes a la organización seleccionada: </div>'],
    [res.ErrorTransferStoreOriginDestiny, '<div>Los siguientes registros contienen la misma tienda como origen y destino: </div>'],
    [res.ErrorTransferOrganization, '<div>La organización selecciona no existe.</div>'],
    [res.ErrorTransferStyleOrganization, '<div>Los siguientes estilos variedad no existen en la Organización seleccionada:</div>'],
    [res.ErrorTransferStyleVariety, '<div>Los siguientes estilos variedad no existen:</div>'],
    [res.ErrorTransferStyleSizeOrganization, '<div>Los siguientes estilo variedad talla no existen en la Organización seleccionada:</div>'],
    [res.ErrorTransferStyleSize, '<div>Los siguientes estilo variedad talla no existen:</div>'],
    [res.ErrorTransferStyleQuantity, '<div>Los siguientes estilo variedad talla no cuentan con una cantidad válida:</div>'],
    [res.ErrorTransferStyleSizeMultiRow, '<div>Los siguientes registros Tienda origen -> Tienda destino -> Estilo variedad -> Talla cuentan con registros repetidos. <br>¿Quieres guardar agrupando estos renglones?</br></div>'],
    [res.ErrorTransferTaskCreate, '<div>Información de Traspaso guardada correctamente. No fue posible crear las tareas de traspasos.</div>'],
    [res.ErrorTransferCountToCreate, '<div>No fue posible obtener los registros almancenados al crear el traspaso.</div>'],
    [res.ErrorTransferWithDetCreate, '<div>No fue posible determinar si los registros se almacenaron correctamente. Verifique y/o intente de nuevo.</div>'],
    [res.ErrorTransferDuplicateToday, '<div>Ya existe un traspaso con este folio. Intente nuevamente para crear una versión con sufijo.</div>'],
    [res.ErrorTransferMaxVersionsReached, '<div>Se ha alcanzado el l\u00edmite de versiones disponibles para este folio.</div>'],
    [res.ErrorTransferMaxVersionsPartial, 'Los siguientes folios han alcanzado el l\u00edmite de versiones y no se pueden crear:'],
    [res.ErrorTransferMaxVersionsPartialConfirm, '\u00bfDesea continuar creando solo los folios que s\u00ed se pueden generar?'],
    [res.ErrorTransferNetworkRetry, '<div>No se pudo confirmar si el traspaso fue creado. Es posible que el proceso siga en ejecución. Por favor espere unos minutos antes de intentar de nuevo.</div>'],
    [res.ErrorTransferBatchPartial, '<div>Algunos traspasos no pudieron crearse. Los siguientes pares origen → destino → sector fallaron:</div>'],
    [res.Retry, 'Reintentar'],
    [res.TransferRequestCreatedSuccessfully, '<div>Solicitud de traspaso creada correctamente.</div>'],
    [res.DuplicateWillCreateWithSuffix, 'Se crearán con sufijo de versión'],
    [res.DuplicateBlockedByMaxVersions, 'No se pueden crear (límite de versiones alcanzado)'],
    [res.DuplicateExistingCode, 'Folio existente'],
    [res.DuplicateWillBeCreatedAs, 'Se creará como'],
    [res.DuplicateConfirmMessage, 'Ya existen traspasos con estos folios. ¿Desea crear versiones adicionales con sufijo?'],
    [res.DuplicateSummaryNewTransfers, '{0} traspasos se crearán normalmente (sin conflicto)'],
    [res.UnprocessedRecords, 'Registros no procesados'],
    [res.DeactivateRequests, 'Cancelar Solicitudes'],
    [res.DeactivateSuccess, 'Las solicitudes seleccionadas fueron desactivadas correctamente'],
    [res.DeactivateConfirm, 'Desactivar'],
    [res.DeactivateSuccessCount, 'desactivadas'],
    [res.DeactivateFailedCount, 'no procesadas'],
    [res.DeactivateStoppedByLock, 'Detenido: ventana de bloqueo alcanzada'],
    [res.DeactivateIrreversibleWarning, 'Esta acción no se puede revertir. Las tareas desactivadas no podrán reactivarse.'],
    [res.DeactivateHoldToConfirm, 'Mantener presionado el botón para confirmar'],
    [res.DeactivateScheduledFor, 'Tarea programada para'],
    [res.Selected, 'seleccionadas'],
    [res.ValidatingStores, 'Validando tiendas'],
    [res.ValidatingStyles, 'Validando estilos'],
    [res.ValidatingDuplicates, 'Verificando duplicados'],
    [res.CreatingRequests, 'Creando solicitudes'],
    [res.ConfirmLeaveWhileProcessing, 'Hay un proceso en curso. Si sales, solo se guardará lo ya procesado. ¿Estás seguro de salir?'],

    // Transfer Store
    [res.ObtainingTransfersBetweenStores, 'Obteniendo los traspasos entre tiendas'],
    [res.ObtainingTransfersInTransit, 'Obteniendo los traspasos en tránsito'],
    [res.PackageCollectionDate, 'Fecha Recolección'],
    [res.EmployeeCollectionConfirm, 'Empleado Confirma Recolección'],
    [res.GuideCollection, 'Guia Recolección'],
    [res.CommentCollection, 'Comentarios Recolección'],

    // Label Design
    [res.LabelDesign, 'Diseño de Etiquetas'],
    [res.PriceType, 'Tipo de Precio'],
    [res.LabelType, 'Tipo de etiqueta'],
    [res.LabelOriginaPrice, 'Precio Original'],
    [res.LabelSalePrice, 'Precio Venta'],
    [res.AditionalRow, 'Fila Adicional'],
    [res.PercentDiscount, 'Porcentaje de descuento'],
    [res.SelectLabelType, 'Seleciona un tipo de etiqueta'],
    [res.SelectBarcodeType, 'Seleciona un tipo de código de barras'],
    [res.SelectAditionalRow, 'Seleciona una opción para la fila agregada'],
    [res.PriceLabelSuccessfully, 'Diseño de etiqueta guardado exitosamente'],

    // Barcode examples
    [res.SkuExampleCode, '1020073003220'],
    [res.UPCExampleCode, 'X004538000076'],
    [res.EANExampleCode, '7500535167108'],

    // Default
    [res.ErrorUnknown, 'Error desconocido'],
    [res.AllSelected, 'Todo seleccionado'],
    [res.SmallerDateThan, 'La fecha fin no puede ser menor a fecha inicio'],
    [res.GreaterDateThan, 'La fecha inicio no puede ser mayor a fecha fin'],
    [res.RestockReport, 'Reporte Resurtibles'],
    [res.Empty, '(Vacío)'],
    [res.FolioSAC, 'Folio SAC'],
    [res.SelectAStore, 'Selecciona una tienda'],

    // PreIroned Inventory
    [res.Failures, 'Errores'],
    [res.ErrorMessageGenerateDetails, 'No se ha generado el detalle, generé el detalle he intente nuevamente.'],
    [res.FailureDate, 'Fecha del error'],
    [res.FailureType, 'Tipo de error'],
    [res.StoreCharge, 'Cargo tienda'],
    [res.FactoryCharge, 'Cargo fabrica'],
    [res.Regularization, 'Regularización'],
    [res.ThereAreErrorNoDownload, 'Aún existen errores, no se puede descargar el archivo.'],
    [res.NoFileCharged, 'No hay archivo cargado, no se puede proceder con el detalle.'],

    // Dashbaoard WareEntry
    [res.WareEntryDetail, 'Detalle de entrada de mercancías'],
    [res.DownloadInvoice, 'Descargar Factura'],
    [res.AmountReceived, 'Cantidad Recibida'],
    [res.AmountEntry, 'Cantidad Ingresada'],
    [res.EnteredTo100, 'Ingresado al 100%'],
    [res.EnteredWithDiff, 'Ingresado con diferencia'],
    [res.PendingToEntry, 'Pendiente de ingreso'],
    [res.Percentage, 'Porcentaje'],
    [res.NumInvoices, 'Num de facturas'],
    [res.BilledUnits, 'Unidades facturadas'],
    [res.UnitsEntered, 'Unidades ingresadas'],

    //Returns
    [res.PiecesForReturn, 'Piezas autorizadas para devolución'],
    [res.SeeSettings, 'Ver configuración'],
    [res.AlertEnterAnAmount, 'Ingrese una cantidad'],
    [res.NoticeReturnConfiuration, 'Ya existe una configuración con los campos seleccionados para esta tienda. ¿Desea sobreescribirla?'],
    [res.AlertAmountMustGreaterThan0, 'La cantidad debe ser mayor a 0'],
    [res.CorporateReturns, 'Devoluciones Corporativas'],
    [res.ReferenceRequestReturn, 'Folio Solicitud de Devolución'],
    [res.ReturnRequest, 'Solicitar Devolución'],
    [res.UploadReturnFile, 'Subir archivo de devoluciones'],
    [res.Division, 'División'],
    [res.CedisPlant, 'CEDIS'],
    [res.EventLog, 'Log de Eventos'],
    [res.MaximiumDateRequired, 'Fecha Máx. Requerida'],
    [res.EmptyLayout, 'El layout cargado está vacío'],
    [res.Cedis, 'Cedis'],

    
    // Invoicement
    [res.Invoicement, 'Facturación'],
    [res.Invoices, 'Facturas'],
    [res.Requester, 'Solicitante'],
    [res.InvoicementDate, 'Fecha de facturación'],
    [res.CreationDate, 'Fecha de creación'],
    [res.BoxQuantity, 'Cantidad caja'],
    [res.DiffAmountSentEntry, 'Dif. Cant. Env/Ing'],
    [res.DiffDaysReceivedEntry, 'Días Rec/Ing'],
    [res.DiffDaysSentReceived, 'Días Env/Rec'],
    [res.Provider, 'Proveedor'],
    [res.GuideNumber, '# Guía'],
    [res.DetailShipmentGuides, 'Detalle guías de envío'],
    [res.Expiration, 'Vencido'],
    [res.PartialEntry, 'Ingresado Parcial'],
    [res.CompleteEntry, 'Ingresado Completo'],
    [res.UnknownStatus, 'Desconocido'],
    [res.Without_Reception, 'Ingresado Sin Recepción'],

    // Logger Layouts
    [res.LoggerLayout, 'Bitácora layouts'],
    [res.LayoutCode, 'Código layout'],
    [res.Username, 'Nombre de usuario'],
    [res.IncidenceWithLayout, 'Incidencia con layout'],
    [res.IncidenceDate, 'Fecha de incidencia'],
    
    [res.Sector, 'Sector'],

    // Warning messages
    [res.warningMessage, 'Aviso'],
    [res.AdviceSelectOptionStoreField, 'Seleccione una opción válida para el campo de tienda.'],
    [res.StatusTask, 'Estatus Tarea'],
    [res.NoOrganizationAssigned, 'Sin organización asignada'],

    // store report checklist
    [res.Executive, 'Ejecutivo'],
    [res.ScoreExt, 'Calificación exterior'],
    [res.ScoreInt, 'Calificación interior'],
    [res.ScoreVar, 'Calificación varios'],
    [res.ActivityDate, 'Fecha de actividad'],

    // Store report checklist change level
    [res.AlertCouldNotGetChangeLevelInstruction, 'No fue posible obtener el archivo. Verifique que cuenta con uno asignado o reintente nuevamente.'],

    // Users Admin
    [res.UsersAdmin, 'Administración de Usuarios'],
    [res.Account, 'Cuenta'],
    [res.ActiveDirectory, 'Directorio Activo'],
    [res.Domain, 'Dominio'],
    [res.Password, 'Contraseña'],
    [res.ApiUser, 'Usuario API'],
    [res.CustomUser, 'Usuario Personalizado'],
    [res.Confirmed, 'Confirmado'],
    [res.UserSavedSuccessfully, 'Usuario guardado con exito!'],
    [res.UserSaveFailed, 'Error al guardar el usuario'],
    [res.AdminRoles, 'Administrar Roles'],
    [res.Roles, 'Roles'],
    [res.RolesUpdatedSuccessfully, 'Roles actualizados con exito!'],
    [res.RolesUpdateFailed, 'Error al actualizar los roles'],
    [res.AreYouSureDefault, '¿Estás seguro de que deseas realizar esta operación?'],
    [res.Permissions, 'Permisos'],
    [res.UserMustHaveOnlyOneRole, 'El usuario debe tener solo un rol asignado'],
    [res.UserAlreadyExists, 'El usuario ya existe'],
    [res.UserEditError, 'Error al intentar editar el usuario'],
    [res.ErrorGettingRoles, 'Error al intentar obtener los roles'],
    [res.ErrorSavingRoles, 'Error al intentar guardar los roles'],
    [res.ErrorGettingData, 'Error al intentar obtener los datos'],
    [res.ErrorGettingPermissions, 'Error al intentar obtener los permisos'],
    [res.ErrorSavingPermissions, 'Error al intentar guardar los permisos'],
    [res.GeneratePassword, 'Generar contraseña aleatoria'],

    [res.UnsoldItemSize, 'Artículos negados para venta'],

    [res.InventoryReport, 'Informe de Inventario'],

    [res.Canceled, 'Cancelado'],
    [res.Manifest, 'Manifiesto'],
    [res.ParcelGuide, 'Guia Parcial'],
    [res.Guide, 'Guia'],
    [res.ASNCodes, 'Codigos ASN'],
    [res.ASNCode, 'Codigo ASN'],
    [res.CartonCode, 'Codigo Carton'],
    [res.DetailCartonGuide, 'Detalle Cartón / Guia'],
    [res.ManifestNumber, 'Numero Manifiesto'],
    [res.EntryInventory, 'Entrada Inventario'],
    [res.ShipmentASNDetail, 'Ingreso de Mercancía ASN Detalle'],
    [res.ReceptionDate, 'Fecha Recepción'],
    [res.StylesVarietyASN, 'Estilos Variedad ASN'],
    [res.sizeGroupDetCode, 'Codigo Talla'],
    [res.styles, 'Estilos'],
    [res.ExportFileNamePendingTransfers, 'traspasos_pendientes'],
    [res.BulkMyUploads, 'Mis cargas'],
    [res.BulkUploadDetail, 'Detalle de la carga'],
    [res.BulkUploadStartedNotice, 'El proceso de carga fue iniciado. Te avisaremos cuando termine.'],
    [res.BulkJobFinishedNotice, 'Tu carga de traspasos terminó: {0} creados, {1} no procesados.'],
    [res.BulkSuccess, 'Procesados'],
    [res.BulkFailed, 'No procesados'],
    [res.BulkDownloadFailed, 'Descargar no procesados'],
    [res.BulkNoFailedRecords, 'No hay registros no procesados para descargar.'],
    [res.BulkLoadingDetail, 'Cargando detalle...'],
    [res.BulkStatusQueued, 'En cola'],
    [res.BulkStatusProcessing, 'Procesando'],
    [res.BulkStatusDone, 'Completado'],
    [res.BulkStatusCompletedWithErrors, 'Completado con errores'],
    [res.BulkStatusFailed, 'No procesado'],
    [res.BulkStartedDate, 'Inicio'],
    [res.BulkFinishedDate, 'Fin'],
    [res.BulkRowCreated, 'Creado'],
    [res.BulkRowFailed, 'No procesado'],
    [res.BulkRowSkipped, 'Omitido'],
    [res.Refresh, 'Actualizar'],
    [res.ViewDetail, 'Ver detalle'],
    [res.WhatsNewTitle, 'Novedades'],
    [res.WhatsNewLink, 'Ver novedades de esta versión'],
    [res.WhatsNewAdded, 'Nuevo'],
    [res.WhatsNewImproved, 'Mejorado'],
    [res.WhatsNewFixed, 'Corregido'],
    [res.WhatsNewGotIt, 'Entendido']
]);
